export const state = () => ({
  isSilentEnabled: false
})

export const mutations = {
  SET_SILENT_STATUS(state, status) {
    state.isSilentEnabled = !!status
  }
}

export const getters = {
  isSilentEnabled: (state) => state.isSilentEnabled
}
